import React from 'react';
import ReactDOM from 'react-dom/client';
import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import './css/index.css';
import Home from './views/Home';
import Contact from './views/Contact';
import Error from './views/Error';
import Bio from './views/Bio';
import Blogs from './views/Blogs';
import reportWebVitals from './reportWebVitals';
import Previousworks from './views/Previousworks';

const router = createBrowserRouter([{
  path:'/',
  element: <Home/>,
  errorElement:<Error/>
},
{
  path:'/contact',
  element: <Contact/>
},
{
  path:'/bio',
  element: <Bio/>
},
{
  path:'/blogs',
  element: <Blogs/>
},
{
  path:'/previousworks',
  element: <Previousworks/>
}
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode> 
    <RouterProvider router={router}/>
  </React.StrictMode>
);


reportWebVitals(console.log);
